import React, {Component} from 'react';
import {connect} from 'react-redux';
import $ from "jquery";
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";

import {fetchFeedRequest, showCarousal} from "../../../actions/feedAction";
import pathList from "../../../helpers/pathList";
import FeedContent from "../FeedContent"
import FeedUser from "../FeedUser"
import FeedImage from "../FeedImage"
import FeedFooter from "../FeedFooter"
import FeedMenu from "../FeedMenu";
import ShareFeed from "../ShareFeed";
import PollingOptionDetails from "../../Polling/pollingoptiondetails";
import {pageloader,loader} from "../../../actions/utils";
import {Pageloader} from "../../Pageloader";
import './Feed.css';

class Feed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentFeed             : [],
      pagination              : 0,
      current_user            : [],
      friend_suggestion       : [],
      post_id                 : 0,
      total_feed              : 0,
      total_page              : 0,
      toggleStatus            : '',
      toggle_feed_id          : '',
      toggleComment_feed_id   : '',
      currentActiveImage      : 0,
      carousalFeed            : 0,
    };
    this.fetchFeed       = this.fetchFeed.bind(this);
    this.handleScroll    = this.handleScroll.bind(this);
    this.toggleFunction  = this.toggleFunction.bind(this);
    this.showCommentList = this.showCommentList.bind(this);
    this.setActiveImage  = this.setActiveImage.bind(this);
  }
  componentDidMount(){
    pageloader(false);
    this.fetchFeed();
    /* padding problem*/
     /* var scrollTop  = $(window).scrollTop(),
     elementOffset = $('.container').offset().top,
    distance      = (elementOffset - scrollTop);
   
    if(localStorage.getItem('login')){
     
      $('.container').css('padding-top','49px'); 
    }
    localStorage.removeItem('login'); */
   /* if((distance > 0) && (!localStorage.getItem('login'))){
      $('.container').css('padding','10px 15px !important'); 
      //document.getElementsByClassName("content_block").style.padding = "0 0px 0px 55px";
    }
    localStorage.removeItem('login'); */
    window.addEventListener('scroll', this.handleScroll, true);
    /* document.oncontextmenu = function() {
      return false;
    } */


  }
  componentWillUnmount() {
    localStorage.setItem('apicall','0');
  }
  fetchFeed(){
   
    localStorage.setItem('apicall','1');
    this.props.fetchFeedRequest(this.state);
  }
  handleScroll(){
   
    if ($(window).scrollTop() + $(window).height()  ==  $(document).height()) {
      //console.log(888);
      if((this.state.total_page > this.state.pagination) && (window.location.href.includes('feed') == true) && (localStorage.getItem('apicall') == '0')){
        this.fetchFeed();
      }
    }
  }
  setActiveImage(activeIndex,feedId){
    let param = {
      activeIndex  : activeIndex,
      carousalFeed : feedId
    };
    this.props.showCarousal(param);
  }

  toggleFunction(toggleFeed){
    this.setState({
      toggleStatus    : (this.state.toggleStatus == 'is-collapsed') ? '' : 'is-collapsed',
      toggle_feed_id  : toggleFeed
    });
  }
  showCommentList(feedId){
    this.setState({
      toggleComment_feed_id: feedId
    })
  }
  UNSAFE_componentWillUpdate(){
   /*  var scrollTop  = $(window).scrollTop(),
    elementOffset = $('.container').offset().top,
    distance      = (elementOffset - scrollTop);
    if(distance > 0){
      $('.container').css('padding-top','55px'); 
    }  */
  } 
  UNSAFE_componentWillReceiveProps(nextProps,prevProps){

   
    if(nextProps.imagecarousal != this.props.imagecarousal){
      this.setState({
        currentActiveImage      : nextProps.imagecarousal.activeIndex,
        carousalFeed            : nextProps.imagecarousal.carousalFeed,
      })
    }
    
    let totalFeedObj = this.state.currentFeed;
     
    /*fetched liked post response*/
    let matchedIndex = (totalFeedObj).map(function (obj) { 
      return obj.feed_id; 
    }).indexOf(nextProps.updatelikelist.feed_id);
  
  
    if ((nextProps.lastCreatedPost.lastPost.post_id) !== undefined) {
      if (this.state.post_id != nextProps.lastCreatedPost.lastPost.post_id) {
          totalFeedObj.unshift(nextProps.lastCreatedPost.lastPost.post_details);
          this.setState({post_id : nextProps.lastCreatedPost.lastPost.post_id});
          console.log(totalFeedObj);
      }
    }else if(nextProps.lastEditedPost.editPost.post_id !== undefined){
     
      let matchedIndex =    totalFeedObj.map(function (obj) { return obj.feed_id; }).indexOf(nextProps.lastEditedPost.editPost.post_id);
      if(matchedIndex >= 0){
        totalFeedObj[matchedIndex] = nextProps.lastEditedPost.editPost.post_details;
      }
    }else if(nextProps.createpolling.poll_id !== this.props.createpolling.poll_id){
      this.props.fetchFeedRequest({pagination : 0});

    }else{
        // console.log(nextProps.listOfFeed.listfeed.feed_details);
         let feeds = nextProps.listOfFeed.listfeed.feed_details;
         if(nextProps.listOfFeed.listfeed.feed_details != undefined){
          if (nextProps.listOfFeed.pagination == 0) {
            totalFeedObj =  [...nextProps.listOfFeed.listfeed.feed_details];
            
          } else {
            let nextfeed = nextProps.listOfFeed.listfeed.feed_details;
            
            if(nextfeed !== this.props.listOfFeed.listfeed.feed_details){
              Object.keys(nextfeed).map((key) => {
                  totalFeedObj.push(nextfeed[key]);
              });
            }
          } 
         }
    
    }

    if(matchedIndex >= 0) {
     
      totalFeedObj[matchedIndex].my_reaction    = nextProps.updatelikelist.my_reaction;
      totalFeedObj[matchedIndex].total_reaction = nextProps.updatelikelist.total_reaction;
    }
  
    this.setState({
      currentFeed       : totalFeedObj,
      pagination        : nextProps.listOfFeed.pagination + 1,
      current_user      : nextProps.listOfFeed.listfeed.current_user,
      friend_suggestion : nextProps.listOfFeed.listfeed.friend_suggestion,
      total_feed        : nextProps.listOfFeed.listfeed.total_counter,
      total_page        : Math.ceil(nextProps.listOfFeed.listfeed.total_counter / 25)
    },function(){
      localStorage.setItem('apicall','0');
      loader(false);
      if(this.props.delete){ 
         $('#feed_'+nextProps.delete.feed_id).remove(); 
        
      }
    }) 
    
  }
  generateFeedContent(feedList){
    
    let curLanguage = localStorage.getItem('userLanguage');
  
    return Object.keys(feedList).map((item) => {
      let details = feedList[item];
      return (
        <div className="post_box position-relative" key={item} id={`feed_${details.feed_id}`}>
          { (details.data_type == 'Promotion') ? 
              <div className="position-absolute"><img src={curLanguage == 'en' ? "/assets/images/promoted_lebel_small.png" : "/assets/images/promoted_lebel_somali_small.png"} style={{float : "right"}} /></div>
              : null
          } 
          {/* width="50%" */}
          <div className="center_post">
            <div className="post_header">
            
              <FeedUser 
                  post_user={details.post_user} 
                  post_date={details.post_date} 
                 
              />
              { (details.data_type == 'Promotion' || details.data_type == 'GAME POST') ? 
                  null
                  :
                  <FeedMenu 
                      feed_id       ={details.feed_id} 
                      post_id       ={details.post_id} 
                      data_type     ={details.data_type} 
                      toggle_feed_id={this.state.toggle_feed_id} 
                      toggleStatus  ={this.state.toggleStatus} 
                      toggleFunction={this.toggleFunction} 
                      logged_in_user={this.props.currentUserDetails} 
                      post_user     ={details.post_user} 
                      position      ="feed"
                  />
               }
            </div>
            <div className="post_body">
              { (details.data_type == 'POLL') ? 
                  <div className="polling-content">
                    <h5 dangerouslySetInnerHTML={{ __html: ' '+details.content+ ' ' }}></h5>
                  </div>
                : <FeedContent content={details.content}/> 
              }
              {this.checkPollOption(details)}
              {this.checkPostImage(details)}
              {this.checkSharedPost(details)}
            </div>
          </div>
          
            
              <FeedFooter 
                total_reaction={details.total_reaction} 
                my_reaction={details.my_reaction} 
                total_comment={details.total_comment} 
                total_share={details.total_share} 
                data_type={details.data_type} 
                feed_id={details.feed_id} 
                post_id               = {details.post_id} 
                position              = "feed" 
                showCommentList       = {this.showCommentList} 
                toggleComment_feed_id = {this.state.toggleComment_feed_id}
                feed_reaction_details = {details.feed_reaction_details}
                new_post_id           = { this.props.lastCreatedPost.lastPost.post_id}
              />
            
          </div>
      )
    })

  
  }
  checkPollOption(details){
    return(
      (details.data_type == 'POLL') ? 
        <PollingOptionDetails 
          optionDetails = {details.poll_details} 
          voteStatus = {details.poll_vote_status}
          data_type = {details.data_type}
          urlFeedId = {details.feed_id} 
          post_id   = {details.post_id} 
        />          
      : null
    )
  }

  checkSharedPost(details){
    return(
      (details.post_user_from.post_user_from_id != '') ? 
        <ShareFeed parent_post = {details.post_user_from} data_type={details.data_type}/>          
      : null
    )
  }
  checkPostImage(details){
    return (
      ((details.media_details).length > 0) ? 
          <div className="post_content">
            <FeedImage 
              media_details      = {details.media_details} 
              dynamic_class      = "post_img" 
              setActiveImage     = {this.setActiveImage} 
              currentFeed        = {details.feed_id}
              currentActiveImage = {this.state.currentActiveImage} 
              carousalFeed       = {details.feed_id} 
              post_my_reaction   = {details.my_reaction}
              post_total_reaction= {details.total_reaction}
              post_total_comment = {details.total_comment}
              post_total_share   = {details.total_share}
            />
          </div>
      : null
    )
  }
  render() {
    let feedList = this.state.currentFeed || {};
    let feedBox = this.generateFeedContent(feedList);
    return (
      
      <div id="post_arr">
        {feedBox}
        <Pageloader/> 
      </div>
      
    );
  }
}
const mapStateToProps = state => {
  return {
   
    listOfFeed        : state.listfeed, 
    lastCreatedPost   : state.lastpost,
    updatelikelist    : state.updatelikelist.likeFeedResponse,
    imagecarousal     : state.imagecarousal.imageCarousal,
    delete            : state.deletepost.deletePost,
    lastEditedPost    : state.editpost,
    createpolling     : state.newpoll.newPoll,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    fetchFeedRequest: bindActionCreators(fetchFeedRequest, dispatch),
    showCarousal    : bindActionCreators(showCarousal, dispatch),
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Feed));
